var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity, EntityBuilder } from '@decahedron/entity';
import { File } from 'packages/core/File';
var Answer = /** @class */ (function (_super) {
    __extends(Answer, _super);
    function Answer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uuid = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.answer = null;
        _this.type = null;
        _this.time = 0;
        _this.score = 0;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Answer.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (!jsonData.answer) {
            jsonData.answer = {};
        }
        if (this.type === 'file') {
            this.answer = EntityBuilder.buildOne(File, jsonData.answer);
        }
        return this;
    };
    return Answer;
}(Entity));
export { Answer };
